import { render, staticRenderFns } from "./ColorWave.vue?vue&type=template&id=7d08c5e6&scoped=true&"
import script from "./ColorWave.vue?vue&type=script&lang=js&"
export * from "./ColorWave.vue?vue&type=script&lang=js&"
import style0 from "./ColorWave.vue?vue&type=style&index=0&id=7d08c5e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d08c5e6",
  null
  
)

export default component.exports